import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, Result, Button } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import LoginPage from './pages/LoginPage';
import MainLayout from './layouts/MainLayout';
import JjReport from './pages/dashboard/JjReport';
import DealerReport from './pages/dashboard/DealerReport';
import OtherReport from './pages/dashboard/OtherReport';
import AdminDashboard from './pages/dashboard/AdminDashboard';
import InventoryCalc from './pages/dashboard/InventoryCalc';
import CustomerData from './pages/customer/CustomerData';
import ArrivalSign from './pages/customer/ArrivalSign';
import ArrivalSelfPickup from './pages/customer/ArrivalSelfPickup';
import EmbedArrivalSign from './pages/customer/EmbedArrivalSign';
import EmbedSlowInventory from './pages/customer/EmbedSlowInventory';
import SignDocPage from './pages/customer/SignDocPage';
import SignDocViewPage from './pages/customer/SignDocViewPage';
import CustomerStats from './pages/customer/CustomerStats';
import CustomerAuth2 from './pages/customer/CustomerAuth2';
import EmbedCustomerAuth from './pages/customer/EmbedCustomerAuth';
import SupplierAuth from './pages/supplier/SupplierAuth';
import CustomerManage from './pages/customer/CustomerManage';
import ReviewManage from './pages/customer/ReviewManage';
import PersonalCenter from './pages/customer/PersonalCenter';
import DocDownload from './pages/customer/DocDownload';
import PermissionManagement from './pages/system/PermissionManagement';
import DeclarationAdmin from './pages/system/DeclarationAdmin';
import StaffManagement from './pages/system/StaffManagement';
import SystemCleanup from './pages/system/SystemCleanup';
import TestSealQuery from './pages/TestSealQuery';
import MiniSignPage from './pages/MiniSignPage';
import SetPwdPage from './pages/SetPwdPage';
import HomePage from './pages/HomePage';
import { getToken, getUser } from './api';
import './App.css';

function ProtectedRoute({ children }) {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function RouteGuard({ requiredPath, requiredPaths, children }) {
  const user = getUser();
  if (user?.role === 3) return children;

  const raw = sessionStorage.getItem('ar_allowed_paths');
  if (!raw) return children;

  const paths = requiredPaths || (requiredPath ? [requiredPath] : []);

  try {
    const allowed = JSON.parse(raw);
    if (paths.length && !paths.some(p => allowed.includes(p))) {
      return (
        <Result
          status="403"
          title="无访问权限"
          subTitle="您没有权限访问此页面，请联系管理员"
          extra={<Button type="primary" onClick={() => window.location.href = '/home'}>返回首页</Button>}
        />
      );
    }
  } catch { return children; }

  return children;
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/sign/:orderNo" element={<MiniSignPage />} />
          <Route path="/pwd/:signerId" element={<SetPwdPage />} />
          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="home" element={<RouteGuard requiredPath="/home"><HomePage /></RouteGuard>} />
            <Route path="dashboard/jj-report" element={<RouteGuard requiredPath="/dashboard/jj-report"><JjReport /></RouteGuard>} />
            <Route path="dashboard/dealer-report" element={<RouteGuard requiredPath="/dashboard/dealer-report"><DealerReport /></RouteGuard>} />
            <Route path="dashboard/other-report" element={<RouteGuard requiredPath="/dashboard/other-report"><OtherReport /></RouteGuard>} />
            <Route path="dashboard/admin" element={<RouteGuard requiredPath="/dashboard/admin"><AdminDashboard /></RouteGuard>} />
            <Route path="dashboard/inventory-calc" element={<RouteGuard requiredPath="/dashboard/inventory-calc"><InventoryCalc /></RouteGuard>} />
            <Route path="customer/data" element={<RouteGuard requiredPath="/customer/data"><CustomerData /></RouteGuard>} />
            <Route path="customer/arrival-sign" element={<RouteGuard requiredPath="/customer/arrival-sign"><ArrivalSign /></RouteGuard>} />
            <Route path="customer/self-pickup" element={<RouteGuard requiredPath="/customer/self-pickup"><ArrivalSelfPickup /></RouteGuard>} />
            <Route path="customer/arrival-sign/sign-doc" element={<RouteGuard requiredPaths={['/customer/arrival-sign', '/customer/self-pickup']}><SignDocPage /></RouteGuard>} />
            <Route path="customer/arrival-sign/view/:orderNo" element={<RouteGuard requiredPaths={['/customer/arrival-sign', '/customer/self-pickup']}><SignDocViewPage /></RouteGuard>} />
            <Route path="customer/stats" element={<RouteGuard requiredPath="/customer/stats"><CustomerStats /></RouteGuard>} />
            <Route path="customer/auth2" element={<RouteGuard requiredPath="/customer/auth2"><CustomerAuth2 /></RouteGuard>} />
          <Route path="supplier/auth" element={<RouteGuard requiredPath="/supplier/auth"><SupplierAuth /></RouteGuard>} />
            <Route path="customer/manage" element={<RouteGuard requiredPath="/customer/manage"><CustomerManage /></RouteGuard>} />
            <Route path="customer/review" element={<RouteGuard requiredPath="/customer/review"><ReviewManage /></RouteGuard>} />
            <Route path="customer/personal" element={<RouteGuard requiredPath="/customer/personal"><PersonalCenter /></RouteGuard>} />
            <Route path="customer/slow-inventory" element={<Navigate to="/embed/slow-inventory" replace />} />
            <Route path="customer/download" element={<RouteGuard requiredPath="/customer/download"><DocDownload /></RouteGuard>} />
            <Route path="system/permission" element={<RouteGuard requiredPath="/system/permission"><PermissionManagement /></RouteGuard>} />
            <Route path="system/declaration" element={<RouteGuard requiredPath="/system/declaration"><DeclarationAdmin /></RouteGuard>} />
            <Route path="system/staff" element={<RouteGuard requiredPath="/system/staff"><StaffManagement /></RouteGuard>} />
            <Route path="system/cleanup" element={<RouteGuard requiredPath="/system/cleanup"><SystemCleanup /></RouteGuard>} />
            <Route path="test/seal-query" element={<RouteGuard requiredPath="/test/seal-query"><TestSealQuery /></RouteGuard>} />
            <Route path="test/seal-query" element={<RouteGuard requiredPath="/test/seal-query"><TestSealQuery /></RouteGuard>} />
          </Route>
          <Route path="embed/customer-auth" element={<EmbedCustomerAuth />} />
          <Route path="embed/arrival-sign" element={<EmbedArrivalSign />} />
<Route path="embed/slow-inventory" element={<EmbedSlowInventory />} />
          <Route path="s/view/:orderNo" element={
            <ProtectedRoute>
              <div style={{ height: '100vh', padding: 16, background: '#fff' }}>
                <SignDocViewPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}
